import axios, { Method } from 'axios';
import appConfig from '../config';
import { Generation, GenerationId, Mode, Modes, User, UserInput, Conversation, Input } from '../types/common';
import { Plan } from '../types/billing';
import { AUTH_API } from './amplify';

const BASE_URL = appConfig.api.server || '';

const API = {
  getGenerationId: (data: UserInput) => post<GenerationId>(`${BASE_URL}/api/generate`, data),
  fetchGeneration: (id: GenerationId['id']) => get<Generation>(`${BASE_URL}/api/generate/${id}`),
  fetchHistory: (mode: Mode) => get<Generation[]>(`${BASE_URL}/api/history/${mode}`),
  getUser: () => get<User>(`${BASE_URL}/api/user`),
  createUser: () => post<User>(`${BASE_URL}/api/user`),
  getModes: () => get<Modes>(`${BASE_URL}/api/modes`),
  getPlans: () => get<Plan>(`${BASE_URL}/api/payment/products`),
  getConversation: () => get<Conversation>(`${BASE_URL}/api/chat/conversation`),
  sendConversationMessage: (data: Input) => post<Conversation>(`${BASE_URL}/api/chat/conversation/generate`, data),
  deleteConversation: () => deleteReq<Conversation>(`${BASE_URL}/api/chat/conversation`),
};

axios.interceptors.request.use(
  async function (config) {
    if (!config || !config.headers) {
      console.log('No config or config.headers');
      return;
    }

    if (config.method === 'post' && config.url === `${BASE_URL}/api/user`) {
      const token = await AUTH_API.getTokenId();
      config.headers.authorization = `Bearer ${token}`;
      return config;
    }

    const token = await AUTH_API.getAccessToken();
    config.headers.authorization = `Bearer ${token}`;

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

const requestClosure =
  (method: Method) =>
  <T>(url: string, data: any = '', params = '', type = 'application/json') => {
    const headers = {
      ...(method === 'post' || method === 'put' || method === 'patch' ? { 'Content-Type': type } : {}),
    };
    let requestEntity: { [k: string]: any } = {
      headers,
      method,
      url,
      params,
    };
    if (method !== 'delete') {
      requestEntity.data = data;
    }

    return new Promise<T>((resolve, reject) => {
      axios
        .request<T>(requestEntity)
        .then((response) => response.data)
        .then((response) => resolve(response))
        .catch((error) => {
          reject(error.response);
        });
    });
  };

const post = requestClosure('post');
const get = requestClosure('get');
const patch = requestClosure('patch');
const deleteReq = requestClosure('delete');

export default API;
